import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";

const PAYMENTS_BASE = `${apiBaseUrl}/api/payments`;

async function request(path, { accessToken, method = "GET", body } = {}) {
  const response = await fetch(`${PAYMENTS_BASE}${path}`, {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Accept-Language": getStoredLanguage(),
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const payload = isJson ? await response.json() : {};
  if (!response.ok) {
    const error = new Error(payload.error || "Payment request failed");
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function fetchClicToPayConfig(accessToken) {
  return request("/clictopay/config/", { accessToken });
}

export function startClicToPayCheckout(accessToken, packId) {
  return request("/clictopay/checkout/", {
    accessToken,
    method: "POST",
    body: { pack_id: packId },
  });
}

export function verifyClicToPayPayment(accessToken, orderId) {
  return request(`/verify/${encodeURIComponent(orderId)}/`, { accessToken });
}